"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const component_code_1 = require("@patternplate/component-code");
const component_tag_1 = require("@patternplate/component-tag");
const component_text_1 = require("@patternplate/component-text");
const C = require("./info-pane.constants");
exports.StyledInfoPane = styled_components_1.default.div `
  position: relative;
  width: 300px;
  min-height: 300px;
  height: 100%;
  box-sizing: border-box;
  border-radius: ${props => props.hermit
    ? `${C.BORDER_RADIUS}px`
    : `${C.BORDER_RADIUS}px 0 0 ${C.BORDER_RADIUS}px`};
  border-right: 1px solid ${props => props.theme.colors.border};
  border-right-width: ${props => (props.hermit ? 0 : 1)}px;
  overflow: scroll;
  overflow-x: hidden;
  background: ${props => props.theme.colors.background};
`;
exports.StyledInnerPane = styled_components_1.default.div `
  position: relative;
  z-index: 1;
  background: ${props => props.theme.colors.background};
`;
exports.StyledName = styled_components_1.default.div `
  position: relative;
  z-index: 1;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 15px 0 15px;
`;
exports.StyledToolbar = styled_components_1.default.div `
  display: flex;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 0 15px 10px 15px;
`;
exports.StyledDisplayName = styled_components_1.default(component_text_1.Text) `
  flex: 1 0 auto;
  color: ${props => props.theme.colors.color};
  margin-right: 10px;
`;
exports.StyledId = styled_components_1.default(component_text_1.Text) `
  flex: 0 1 auto;
  color: ${props => props.theme.colors.recess};
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.StyledData = styled_components_1.default.table `
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`;
exports.StyledDataCell = styled_components_1.default.td `
  box-sizing: border-box;
  height: 30px;
  padding: 4px 6px;
  border-top: 1px solid ${props => props.theme.colors.border};
  &:first-child {
    padding-left: 20px;
  }
  &:last-child {
    text-align: right;
    padding-right: 15px;
  }
`;
exports.StyledKey = styled_components_1.default(component_text_1.Text) `
  font-weight: bold;
  color: ${props => props.theme.colors.color};
`;
exports.StyledTag = styled_components_1.default(component_tag_1.Tag) `
  display: inline-block;
  padding: 2px 4px;
  margin-top: 1.5px;
  margin-bottom: 1.5px;
  border: 1px solid ${props => props.theme.colors.color};
  border-radius: 3px;
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
    color: ${props => props.theme.colors.color};
  }
  &:nth-child(2n) {
    margin-left: 3px;
  }
`;
exports.StyledCode = styled_components_1.default(component_code_1.Code) `
  width: 100%;
`;
//# sourceMappingURL=info-pane.styles.js.map